import { computed, Injectable, signal } from '@angular/core';
import { LoggedUser } from '../../store/entities/user-management/user/user.model';

@Injectable({
  providedIn: 'root'
})
export class LoggedUserService {
  private _loggedUser = signal<LoggedUser | null>(null);

  // Public readonly signal
  readonly loggedUser = this._loggedUser.asReadonly();

  // Computed signals for common checks
  readonly isLoggedIn = computed(() => this._loggedUser() !== null);
  readonly userFullName = computed(() => this._loggedUser()?.fullName ?? '');
  readonly userEmail = computed(() => this._loggedUser()?.email ?? '');
  readonly userId = computed(() => this._loggedUser()?.id);
  readonly userUid = computed(() => this._loggedUser()?.uid);

  constructor() { }

  public setLoggedUser(data: LoggedUser): void {
    this._loggedUser.update(current => ({
      ...current,
      ...data
    }));
  }

  public getLoggedUser(): LoggedUser | null {
    return this._loggedUser();
  }

  public clearLoggedUser(): void {
    this._loggedUser.set(null);
  }
}
